export default {
    data() {
        return {
            info: {},
            createObj: {},
            urls: [
              'https://store.ptcc9.top/notmaker/user_upload/ba15bc64d0b24c178659372c9c4386bd/2024-10-12%2022:51:21_image.png',
              'https://store.ptcc9.top/notmaker/user_upload/ba15bc64d0b24c178659372c9c4386bd/2024-10-12%2022:51:43_image.png',
              'https://store.ptcc9.top/notmaker/user_upload/ba15bc64d0b24c178659372c9c4386bd/2024-10-12%2022:51:57_image.png',
            ],
            text: [
                {
                    row1: '',//2
                    row2: '成为全球领先的大宗商品供应链一体化服务商。',
                },
                {
                    row1: '',//3
                    row2: '依托供应链整合优势，助推鑫和集团成长为全球领先的一体化服务商。',
                },
                {
                    row1: '',//1
                    row2: '深耕大宗商品供应链一体化,不断提升服务水平。',
                },


            ],
            needs: '',
            tableList: [],
            total: -1,
            dictionaryList: [],
            fangshi: '供货',
            rezhiMin: '',
            rezhiMax: '',
            shangpinpinming: [],
            jiesuanfangshi: [],
            jiaohuofangshiArr: [],
            jiaohuodi: [],
            pageIndex: 1,
            isCreateDialogShow: false,
            rules: {
                pic: this.$verify.ruleEmptyStr(this.$t('请上传')),
                title: this.$verify.ruleEmptyStr(this.$t('请输入商品名')),
                contactPhone: this.$verify.ruleEmptyStr(this.$t('请输入咨询电话')),
                shengyu: this.$verify.rulePrice(this.$t('请输入剩余量，需为正整数')),
                hetong: this.$verify.ruleEmptyStr(this.$t('请上传')),
                fuwuxieyi: this.$verify.ruleEmptyStr(this.$t('请上传')),
                baozhengjine: this.$verify.rulePrice(this.$t('请输入保证金额，需为正整数')),
                status: this.$verify.ruleEmptyStr(this.$t('请选择状态')),
            },
            toolbars: {
                autofocus: false,
                bold: true, // 粗体
                italic: true, // 斜体
                header: true, // 标题
                underline: true, // 下划线
                strikethrough: true, // 中划线
                mark: true, // 标记
                superscript: true, // 上角标
                subscript: true, // 下角标
                quote: true, // 引用
                ol: true, // 有序列表
                ul: true, // 无序列表
                link: true, // 链接
                imagelink: true, // 图片链接
                code: true, // code
                table: true, // 表格
                fullscreen: true, // 全屏编辑
                readmodel: true, // 沉浸式阅读
                htmlcode: true, // 展示html源码
                help: true, // 帮助
                undo: true, // 上一步
                redo: true, // 下一步
                navigation: true, // 导航目录
                alignleft: true, // 左对齐
                aligncenter: true, // 居中
                alignright: true, // 右对齐
                subfield: true, // 单双栏模式
                preview: true, // 预览
            },
        };
    },
    methods: {
        viewProductTable() {
            let jiaohuofangshi = this.jiesuanfangshi.join(',');
            let jiaohuodi = this.jiaohuodi.join(',');
            let shangpinpinming = this.shangpinpinming.join(',');
            this.$http.cusViewProductTable(this.fangshi,jiaohuodi,jiaohuofangshi,shangpinpinming,this.rezhiMin,this.rezhiMax,this.pageIndex).then(res => {
                if (res.code === 200) {
                    for (let item of res.data.list) {
                        this.tableList.push(item);
                    }
                    this.total = res.data.total;
                    this.$forceUpdate();
                }
            })
        },
        selectCondition(field,value) {
            if (field === 'jiesuanfangshi' || field === 'jiaohuodi' || field === 'shangpinpinming') {
                if (value === '') {
                    this[field] = [];
                } else if (!this[field].includes(value)) {
                    if (typeof value === 'object') {
                        this[field] = value;
                    }else {
                        this[field].push(value);
                    }
                }else {
                    if (typeof value === 'object') {
                        this[field] = value;
                    }else {
                        this[field] = this[field].filter(item => item !== value);
                    }
                }
            }else {
                this[field] = value;
            }

            this.tableList = [];
            this.total = 0;
            this.pageIndex = 1;
            this.viewProductTable();
        },
        more() {
            this.pageIndex++;
            this.viewProductTable();
        },
        // 编辑器中的图片上传
        editorImgUpload(pos, $file) {
            const allowedType = ['image/jpg','image/png','image/jpeg','image/gif'];

            let file = $file;

            if (!allowedType.includes(file.type)) {
                this.$hint.message.info('png/jpg/jpeg/gif');
                this.md = this.md.replace('![' + file.name + '](' + pos + ')',''); // 删除这个图片的内容
                return;
            }
            this.$http.uploadFile(file, file.name).then(res => {
                if (res.code === 200) {
                    this.$refs.md.$img2Url(pos, encodeURI(res.data));
                }
            })
        },
        handleCreate() {
            this.$refs['createObj'].validate((valid) => {
                if (valid) {
                    this.createObj.publisherId = this.$store.state.currentUser.id;
                    this.createObj.publisherName = this.$store.state.currentUser.account;
                    this.createObj.fangshi = '求购';
                    this.createObj.status = '正常';
                    this.$http.createProduct(this.createObj).then(res => {
                        if (res.code === 200) {
                            this.isCreateDialogShow = false;
                            this.getTableData();
                        }
                    })
                } else {
                    this.$myAnime.shakeElement('.create-btn',5);
                }
            });
        },

        publishWants() {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }

            if (this.info.status === '已禁用') {
                this.$hint.message.info(this.$t('账号已被禁用'));
                return;
            }

            if (this.info.status === '待完善资料') {
                this.$hint.message.info(this.$t('请先完善个人资料'));
                return;
            }

            if (this.info.status === '待审核') {
                this.$hint.message.info(this.$t('请等待管理员审核通过'));
                return;
            }

            if (this.info.status === '审核未通过') {
                this.$hint.message.info(this.$t('审核未通过，请重新完善资料'));
                return;
            }

            this.isCreateDialogShow = true;
        },
        getUserInfo() {
            if (this.$store.state.currentUser !== null) {
                this.$http.getUserInfo().then(res => {
                    this.info = res.data;
                })
            }
        },

    },
    created() {
        this.viewProductTable();
        this.$http.viewDictionaryAll().then(res => {
            this.dictionaryList = res.data;
        })
        this.getUserInfo();
    }
}
